(function(){
  var section = document.getElementById('storySection');
  var bar = document.getElementById('stickyCta');
  if(!section || !bar) return;

  var ticking = false;
  function toggleBar(){
    ticking = false;
    var fullyScrolledPast = section.getBoundingClientRect().bottom <= 0;
    bar.classList.toggle('visible', fullyScrolledPast);
  }
  function requestToggle(){
    if(!ticking){
      ticking = true;
      window.requestAnimationFrame(toggleBar);
    }
  }

  window.addEventListener('scroll', requestToggle, {passive:true});
  window.addEventListener('resize', requestToggle);
  window.addEventListener('load', toggleBar);
  section.querySelectorAll('img').forEach(function(img){
    if(img.complete){
      toggleBar();
    } else {
      img.addEventListener('load', toggleBar);
    }
  });

  toggleBar();
})();

(function(){
  var studies = [
    {
      title: "Efficacy and tolerability of an undenatured type II collagen supplement in modulating knee osteoarthritis symptoms: a multicenter randomized, double-blind, placebo-controlled study",
      authors: "Lugo JP, Saiyed ZM, Lane NE",
      journal: "Nutrition Journal",
      year: "2016",
      pmid: "PMID: 26822714",
      url: "https://pmc.ncbi.nlm.nih.gov/articles/PMC4731911/",
      quote: "191 volunteers received 40mg/day UC-II, glucosamine + chondroitin, or placebo for 180 days. The UC-II group showed a significantly greater reduction in overall WOMAC score than both placebo (p = 0.002) and glucosamine/chondroitin (p = 0.04)."
    },
    {
      title: "Short-term effects of highly-bioavailable curcumin for treating knee osteoarthritis: a randomized, double-blind, placebo-controlled prospective study",
      authors: "Nakamura T, et al.",
      journal: "Journal of Orthopaedic Science",
      year: "2014",
      pmid: "PMID: 25308211",
      url: "https://pmc.ncbi.nlm.nih.gov/articles/PMC4244558/",
      quote: "In this randomized, placebo-controlled trial, a highly-bioavailable curcumin formulation significantly reduced knee pain scores in osteoarthritis patients compared to placebo, with measurable blood concentrations far exceeding standard curcumin."
    },
    {
      title: "Short-Term Effect of a New Oral Sodium Hyaluronate Formulation on Knee Osteoarthritis: A Double-Blind, Randomized, Placebo-Controlled Clinical Trial",
      authors: "Tashiro T, et al.",
      journal: "Applied Sciences (MDPI)",
      year: "2020",
      pmid: "PMC7564147",
      url: "https://pmc.ncbi.nlm.nih.gov/articles/PMC7564147/",
      quote: "In 60 subjects with symptomatic knee osteoarthritis, oral sodium hyaluronate significantly improved pain VAS and WOMAC pain scores compared to placebo, while reducing participants’ weekly use of NSAIDs and pain medication."
    },
    {
      title: "Palmitoylethanolamide in the Treatment of Chronic Pain: A Systematic Review and Meta-Analysis of Double-Blind Randomized Controlled Trials",
      authors: "Cristiano C, et al.",
      journal: "Nutrients",
      year: "2023",
      pmid: "PMC10053226",
      url: "https://pmc.ncbi.nlm.nih.gov/articles/PMC10053226/",
      quote: "A meta-analysis of double-blind RCTs found ultramicronised PEA consistently reduced chronic pain intensity across studies, supporting its role in modulating the body’s natural pain-signalling pathways."
    }
  ];

  var overlay = document.getElementById('studyModalOverlay');
  var titleEl = document.getElementById('studyModalTitle');
  var metaEl = document.getElementById('studyModalMeta');
  var quoteEl = document.getElementById('studyModalQuote');
  var linkEl = document.getElementById('studyModalLink');
  var closeBtn = document.getElementById('studyModalClose');

  function openStudy(i){
    var s = studies[i];
    if(!s) return;
    titleEl.textContent = s.title;
    metaEl.innerHTML = s.authors + ' &middot; <em>' + s.journal + '</em>, ' + s.year + ' &middot; ' + s.pmid;
    quoteEl.textContent = '“' + s.quote + '”';
    linkEl.setAttribute('href', s.url);
    overlay.classList.add('open');
  }
  function closeStudy(){
    overlay.classList.remove('open');
  }

  document.querySelectorAll('.ing-study-btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      openStudy(parseInt(btn.getAttribute('data-study'), 10));
    });
  });
  closeBtn.addEventListener('click', closeStudy);
  overlay.addEventListener('click', function(e){
    if(e.target === overlay) closeStudy();
  });
})();
